import { Component } from '@theme/component';
import './spider-core.js';
const SpiderGeometry = window.SpiderGeometry;
(function () {
  'use strict';
  if (customElements.get('vp-spider-component')) return;
  const esc = text => String(text).replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  const presets = {
    shop: { wallWidth:'8', wallHeight:'6', bannerWidth:'4', bannerHeight:'2', systemHeight:'4,8', boxHeight:'1', quantity:'1', wire:'left' },
    square: { wallWidth:'6', wallHeight:'8', bannerWidth:'3', bannerHeight:'3', systemHeight:'6', boxHeight:'1', quantity:'1', wire:'left' },
    large: { wallWidth:'8', wallHeight:'10', bannerWidth:'6', bannerHeight:'3', systemHeight:'8', boxHeight:'1', quantity:'1', wire:'right' }
  };
  class SpiderConfigurator extends Component {
    connectedCallback() {
      super.connectedCallback();
      this.initialize();
    }
    updatedCallback() {
      super.updatedCallback();
      this.initialize();
    }
    initialize() {
      this.clearToolStatus();
      this.eventController?.abort();
      this.exportController?.abort();
      this.exportController=null;this.exporting=false;
      this.eventController = new AbortController();
      this.brand = JSON.parse(this.querySelector('[data-spider-branding]').textContent);
      const decoder=document.createElement('textarea');
      this.copy=Object.fromEntries(Object.entries(JSON.parse(this.querySelector('[data-spider-copy]').textContent)).map(([key,value])=>{
        decoder.innerHTML=value;
        return [key,decoder.value];
      }));
      const toolStatus=this.querySelector('[data-tool-status]');
      toolStatus.addEventListener('pointerenter',()=>this.pauseToolStatus(),{signal:this.eventController.signal});
      toolStatus.addEventListener('pointerleave',()=>this.dismissToolStatusLater(),{signal:this.eventController.signal});
      this.addEventListener('keydown',event=>{if(event.key==='Escape') this.clearToolStatus();},{signal:this.eventController.signal});
      this.language = this.dataset.language.startsWith('da') ? 'da-DK' : 'en-GB';
      this.format = new Intl.NumberFormat(this.language, { maximumFractionDigits:2 });
      this.step ??= 0;
      this.view ??= 'mounted';
      const decoded = SpiderGeometry.decode(window.location.search);
      this.raw ??= decoded.raw;
      this.addEventListener('beforeinput', event => {
        const input=event.target;
        if (!input.matches('[data-field]') || event.data===null || !event.inputType.startsWith('insert')) return;
        const value=input.value.slice(0,input.selectionStart)+event.data+input.value.slice(input.selectionEnd);
        if (!this.acceptsNumber(input.dataset.field,value)) event.preventDefault();
      }, { signal: this.eventController.signal });
      this.addEventListener('input', event => {
        if (event.target.matches('[data-range]')) {
          const key = event.target.dataset.range;
          this.raw[key] = this.f(Number(event.target.value));
          this.querySelector(`[data-field="${key}"]`).value = this.raw[key];
        } else if (event.target.matches('[data-field]')) {
          const input=event.target, key=input.dataset.field;
          if (!this.acceptsNumber(key,input.value)) {
            const caret=input.selectionStart;
            input.value=this.raw[key];
            input.setSelectionRange(Math.min(caret,input.value.length),Math.min(caret,input.value.length));
            return;
          }
          this.raw[key] = input.value;
        } else return;
        this.render();
      }, { signal: this.eventController.signal });
      this.addEventListener('focusout', event => {
        if (!event.target.matches('[data-field]')) return;
        this.finishNumber(event.target);
      }, { signal: this.eventController.signal });
      this.addEventListener('keydown', event => {
        if (event.key==='Enter' && event.target.matches('[data-field]')) {
          event.preventDefault();
          this.finishNumber(event.target);
        }
      }, { signal: this.eventController.signal });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-wire]')) { this.raw.wire = event.target.value; this.render(); }
        if (event.target.matches('[data-import-file]') && event.target.files[0]) this.openSavedFile(event.target.files[0]);
      }, { signal: this.eventController.signal });
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-next')) this.setStep(1);
        if (button.hasAttribute('data-back')) this.setStep(0);
        if (button.hasAttribute('data-preset')) { this.raw={...presets[button.dataset.preset]}; this.syncInputs(); this.render(); }
        if (button.hasAttribute('data-view')) { this.view=button.dataset.view; this.render(); }
        if (button.hasAttribute('data-reset')) {
          this.raw={...SpiderGeometry.defaults}; this.view='mounted'; this.syncInputs(); this.setStep(0);
          this.querySelectorAll('form').forEach(form=>form.reset());
          this.clearToolStatus();
          this.querySelector('[data-request-status]').textContent='';
          const url=new URL(window.location.href);
          if (url.searchParams.get('spider')==='1') { url.search=''; history.replaceState(null,'',url); }
          this.render();
          this.showToolStatus(this.copy.reset_done,button);
        }
        if (button.hasAttribute('data-share')) {
          if (!this.result.valid) return;
          this.copyLayout(button);
        }
        if (button.hasAttribute('data-import')) this.querySelector('[data-import-file]').click();
        if (button.hasAttribute('data-download')) {
          if (!this.result.valid) return;
          this.downloadConfiguration(button);
        }
      }, { signal: this.eventController.signal });
      const form=this.querySelector('form');
      form.addEventListener('submit',event=> {
        if (!this.result.valid) { event.preventDefault(); this.setStep(this.result.errors.some(error=>error.field!=='quantity')?0:1); return; }
        this.updateHidden();
        if (this.dataset.mode==='shopify') return;
        event.preventDefault();
        if (!form.reportValidity()) return;
        const data=new FormData(form);
        const text=[this.copy.configuration,this.summary(),'',[this.copy.name,data.get('contact[name]')].join(': '),[this.copy.company,data.get('contact[company]')].join(': '),[this.copy.email,data.get('contact[email]')].join(': '),[this.copy.phone,data.get('contact[phone]')].join(': '),[this.copy.message,data.get('contact[body]')].join(': '),'',this.copy.technical_note].join('\n');
        this.save('SpiderSystem-forespoergsel.txt',text,'text/plain;charset=utf-8');
        this.querySelector('[data-request-status]').textContent=this.copy.request_saved;
      }, { signal: this.eventController.signal });
      this.syncInputs(); this.setStep(this.step, false);
      if (decoded.supplied) this.showToolStatus(this.copy.share_loaded,this.querySelector('[data-share]'),'info');
      if (this.querySelector('[data-request-success]') || window.location.hash.startsWith('#SpiderContact-')) this.setStep(1,false);
    }
    disconnectedCallback() {
      super.disconnectedCallback();
      this.clearToolStatus();
      this.eventController?.abort();
      for (const [url,timer] of this.downloads ?? []) { clearTimeout(timer); URL.revokeObjectURL(url); }
      this.downloads?.clear();
    }
    clearToolStatus() {
      clearTimeout(this.toolStatusTimer);
      clearTimeout(this.toolStatusClearTimer);
      const status=this.querySelector('[data-tool-status]');
      if(status) {
        status.textContent='';
        status.classList.remove('is-fading');
      }
    }
    pauseToolStatus() {
      clearTimeout(this.toolStatusTimer);
      clearTimeout(this.toolStatusClearTimer);
      this.querySelector('[data-tool-status]').classList.remove('is-fading');
    }
    dismissToolStatusLater() {
      const status=this.querySelector('[data-tool-status]');
      this.pauseToolStatus();
      if(!status.textContent || !['success','info'].includes(status.dataset.tone)) return;
      this.toolStatusTimer=setTimeout(()=>{
        status.classList.add('is-fading');
        this.toolStatusClearTimer=setTimeout(()=>this.clearToolStatus(),200);
      },5000);
    }
    positionToolStatus() {
      const status=this.querySelector('[data-tool-status]');
      const tool=status?.closest('.sp-tool');
      if(!tool || !status.textContent) return;
      status.style.width='max-content';
      status.style.maxWidth=Math.min(320,window.innerWidth-32)+'px';
      const width=status.getBoundingClientRect().width;
      const toolRect=tool.getBoundingClientRect();
      const rect=tool.querySelector('button').getBoundingClientRect();
      const left=Math.max(16,Math.min(rect.left+rect.width/2-width/2,window.innerWidth-width-16));
      status.style.left=(left-toolRect.left)+'px';
      const height=status.getBoundingClientRect().height;
      const below=rect.bottom+10;
      const overlaps=[...tool.parentElement.querySelectorAll('button')].some(button=>{
        if(button===tool.querySelector('button')) return false;
        const other=button.getBoundingClientRect();
        return left<other.right && left+width>other.left && below<other.bottom && below+height>other.top;
      });
      const above=(below+height>window.innerHeight-12 || overlaps) && rect.top-height-10>=12;
      status.dataset.placement=above?'above':'below';
      status.style.top=((above?rect.top-height-10:below)-toolRect.top)+'px';
      status.style.setProperty('--sp-toast-arrow',Math.max(20,Math.min(width-20,rect.left+rect.width/2-left))+'px');
    }
    showToolStatus(message,button,tone='success') {
      this.clearToolStatus();
      const status=this.querySelector('[data-tool-status]');
      button.closest('.sp-tool').append(status);
      status.dataset.tone=tone;
      const icon=document.createElementNS('http://www.w3.org/2000/svg','svg');
      icon.setAttribute('viewBox','0 0 20 20');
      icon.setAttribute('aria-hidden','true');
      const mark=tone==='success'?'M5.5 10l3 3 6-6':tone==='error'?'M10 5.5v5M10 14h.01':'M10 9v5M10 5.5h.01';
      icon.innerHTML='<circle cx="10" cy="10" r="9" fill="currentColor"/><path d="'+mark+'" stroke="white" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>';
      const text=document.createElement('span');
      text.textContent=message;
      status.replaceChildren(icon,text);
      this.positionToolStatus();
      this.dismissToolStatusLater();
    }
    async copyLayout(button) {
      this.clearToolStatus();
      button.disabled=true;
      try {
        await navigator.clipboard.writeText(SpiderGeometry.encode(this.raw,window.location.href));
        this.showToolStatus(this.copy.share_copied,button);
      } catch {
        this.showToolStatus(this.copy.share_failed,button,'error');
      } finally {
        button.disabled=!this.result.valid;
      }
    }
    getBranding() {
      const root=this.closest('.spider-site');
      const probe=document.createElement('span');
      probe.hidden=true;
      root.append(probe);
      const palette={};
      const canvas=document.createElement('canvas');
      canvas.width=1;canvas.height=1;
      const context=canvas.getContext('2d');
      for(const key of ['forest','coral','paper','sage','muted','line']) {
        probe.style.color='var(--'+key+')';
        context.clearRect(0,0,1,1);
        context.fillStyle=getComputedStyle(probe).color;
        context.fillRect(0,0,1,1);
        const [red,green,blue,alpha]=context.getImageData(0,0,1,1).data;
        palette[key]=alpha===255?'#'+[red,green,blue].map(channel=>channel.toString(16).padStart(2,'0')).join(''):'rgba('+red+','+green+','+blue+','+(alpha/255)+')';
      }
      probe.remove();
      return { ...this.brand, palette, body:getComputedStyle(root).fontFamily, heading:getComputedStyle(root.querySelector('h3')).fontFamily, headingWeight:getComputedStyle(root.querySelector('h3')).fontWeight };
    }
    async exportAssets(brand, signal) {
      let incomplete=false;
      const get=async (url, kind)=> {
        if(!url) return '';
        try {
          const response=await fetch(new URL(url,window.location.href),{credentials:'omit',signal});
          if(!response.ok) throw new Error('Asset unavailable');
          const bytes=new Uint8Array(await response.arrayBuffer());
          if(bytes.length>150000) throw new Error('Asset too large');
          const type=response.headers.get('content-type').split(';')[0];
          if(kind==='logo' && !['image/png','image/jpeg','image/webp','image/gif'].includes(type)) throw new Error('Unsupported logo');
          if(kind==='font' && String.fromCharCode(...bytes.slice(0,4))!=='wOF2') throw new Error('Unsupported font');
          let binary='';
          for(let i=0;i<bytes.length;i+=8192) binary+=String.fromCharCode(...bytes.subarray(i,i+8192));
          return 'data:'+(kind==='font'?'font/woff2':type)+';base64,'+btoa(binary);
        } catch { incomplete=true; return ''; }
      };
      const fonts=[...new Map(brand.fonts.filter(font=>font.url).map(font=>[font.url,font])).values()];
      const [logo,...faces]=await Promise.all([get(brand.logo,'logo'),...fonts.map(async font=> {
        const uri=await get(font.url,'font');
        return uri?'@font-face{font-family:'+JSON.stringify(font.family.replace(/^["']|["']$/g,''))+';font-style:'+font.style+';font-weight:'+font.weight+';src:url("'+uri+'") format("woff2")}':'';
      })]);
      return {logo,fontCss:faces.join(''),incomplete};
    }
    async downloadConfiguration(button) {
      if(this.exporting) return;
      const snapshot={raw:{...this.raw},view:this.view,result:this.result,summary:this.summary(),brand:this.getBranding(),drawing:this.querySelector('[data-drawing] svg').cloneNode(true)};
      const controller=new AbortController();
      this.exportController=controller;
      const timeout=setTimeout(()=>controller.abort(),5000);
      this.exporting=true;button.disabled=true;this.showToolStatus(this.copy.download_preparing,button,'progress');
      try {
        const assets=await this.exportAssets(snapshot.brand,controller.signal);
        if(!this.isConnected || this.exportController!==controller) return;
        this.save('SpiderSystem-konfiguration.svg',this.exportSvg(assets,snapshot),'image/svg+xml;charset=utf-8');
        this.showToolStatus(assets.incomplete?this.copy.download_fallback:this.copy.download_saved,button,assets.incomplete?'info':'success');
      } catch {
        if(this.isConnected && this.exportController===controller) this.showToolStatus(this.copy.download_failed,button,'error');
      } finally {
        clearTimeout(timeout);
        if(this.exportController===controller) {
          this.exportController=null;this.exporting=false;
          if(this.isConnected) button.disabled=!this.result.valid;
        }
      }
    }
    f(value) { return this.format.format(value); }
    acceptsNumber(key,value) {
      const max=SpiderGeometry.ranges[key][1];
      const digits=String(max).length;
      const pattern=new RegExp(key==='quantity'?'^\\d{0,'+digits+'}$':'^\\d{0,'+digits+'}(?:[.,]\\d?)?$');
      return pattern.test(value) && (value==='' || /^[.,]$/.test(value) || Number(value.replace(',','.'))<=max);
    }
    finishNumber(input) {
      const key=input.dataset.field, [min,max]=SpiderGeometry.ranges[key];
      const value=Number(input.value.replace(',','.'));
      const fallback=SpiderGeometry.parse(SpiderGeometry.defaults[key]);
      const number=input.value==='' || !Number.isFinite(value)?fallback:value;
      const bounded=Math.max(min,Math.min(max,number));
      const rounded=key==='quantity'?Math.round(bounded):Math.round(bounded*10)/10;
      this.raw[key]=key==='quantity'?String(rounded):this.f(rounded);
      input.value=this.raw[key];
      this.render();
    }
    syncInputs() {
      this.querySelectorAll('[data-field]').forEach(input=>{ input.value=this.raw[input.dataset.field]; });
      this.querySelectorAll('[data-wire]').forEach(input=>{input.checked=input.value===this.raw.wire;});
    }
    syncRanges() {
      this.querySelectorAll('[data-range]').forEach(slider=>{
        const value=SpiderGeometry.parse(this.raw[slider.dataset.range]);
        if (Number.isFinite(value)) slider.value=String(value);
        const invalid=!Number.isFinite(value)||value<Number(slider.min)||value>Number(slider.max)||Math.abs(value*10-Math.round(value*10))>0.000001;
        slider.setAttribute('aria-invalid',String(invalid));
        slider.setAttribute('aria-valuetext',this.f(Number(slider.value))+' m');
      });
    }
    setStep(step,focus=true) {
      this.step=step===1?1:0;
      this.querySelectorAll('[data-panel]').forEach(panel=>{panel.hidden=Number(panel.dataset.panel)!==this.step;});
      this.querySelector('[data-back]').hidden=this.step===0;
      this.querySelector('[data-next]').hidden=this.step===1;
      this.querySelector('[data-preset-examples]').hidden=this.step!==0;
      this.render();
      if(focus) this.querySelector(`[data-panel="${this.step}"]`).querySelector('h3,input').focus({preventScroll:true});
    }
    errorText(error) {
      let text=this.copy['error_'+error.code];
      for(const [key,value] of Object.entries(error)) if(typeof value==='number') text=text.replace('{'+key+'}',this.f(value));
      return `${this.copy[error.field]}: ${text}`;
    }
    summary() {
      const r=this.result, v=r.values;
      if(!r.valid) return this.copy.invalid;
      return [this.copy.configuration,`${this.copy.step_wall}: ${this.f(v.wallWidth)} × ${this.f(v.wallHeight)} m`,`${this.copy.step_banner}: ${this.f(v.bannerWidth)} × ${this.f(v.bannerHeight)} m (${this.f(r.area)} m²)`,`${this.copy.frame_label}: ${this.f(r.frameWidth)} × ${this.f(r.frameHeight)} m`,`${this.copy.systemHeight}: ${this.f(v.systemHeight)} m`,`${this.copy.boxHeight}: ${this.f(v.boxHeight)} m`,`${this.copy.wire}: ${this.copy[v.wire]}`,`${this.copy.clearance_label}: ${this.f(r.clearance)} m`,`${this.copy.quantity}: ${this.f(v.quantity)}`].join('\n');
    }
    updateHidden() {

      const summary = this.summary();

      this.querySelector('[data-config-hidden]').value = summary;

      const body = this.querySelector('[data-message-hidden]');

      if (body) {

        const message = this.querySelector('[data-request-message]').value.trim();

        body.value = [summary, '', this.copy.message + ': ' + message, '', this.copy.technical_note].join('\n');

      }

    }

    exportSvg(assets,snapshot) {
      const {result:r,raw,view,summary,brand:b,drawing}=snapshot, v=r.values;
      const report=document.createElementNS('http://www.w3.org/2000/svg','svg');
      for(const [key,value] of Object.entries({viewBox:'0 0 900 1080',width:'900',height:'1080',role:'img','aria-labelledby':'spidersystem-file-title spidersystem-file-desc'})) report.setAttribute(key,value);
      const p=b.palette;
      const text=(x,y,value,size=13,extra='')=>'<text x="'+x+'" y="'+y+'" font-size="'+size+'" '+extra+'>'+esc(value)+'</text>';
      const fill=color=>'fill="'+esc(color)+'"';
      const left=[
        [this.copy.step_wall,this.f(v.wallWidth)+' × '+this.f(v.wallHeight)+' m'],
        [this.copy.step_banner,this.f(v.bannerWidth)+' × '+this.f(v.bannerHeight)+' m'],
        [this.copy.area_label,this.f(r.area)+' m²'],
        [this.copy.frame_label,this.f(r.frameWidth)+' × '+this.f(r.frameHeight)+' m'],
        [this.copy.clearance_label,this.f(r.clearance)+' m']
      ];
      const right=[
        [this.copy.systemHeight,this.f(v.systemHeight)+' m'],
        [this.copy.boxHeight,this.f(v.boxHeight)+' m'],
        [this.copy.wire,this.copy[v.wire]],
        [this.copy.quantity,this.f(v.quantity)]
      ];
      const column=(rows,x)=>rows.map(([name,value],i)=>text(x,695+i*47,name,12,fill(p.muted))+text(x,714+i*47,value,17,'font-weight="600"')).join('');
      const lines=[];
      for(const word of this.copy.technical_note.split(/\s+/)) {
        if(!lines.length || lines[lines.length-1].length+word.length>110) lines.push(word);
        else lines[lines.length-1]+=' '+word;
      }
      const titleX=assets.logo?120:48;
      const company=b.name.length>38?b.name.slice(0,37)+'…':b.name;
      const email=b.email.length>45?b.email.slice(0,44)+'…':b.email;
      const link=SpiderGeometry.encode(raw,window.location.href);
      report.innerHTML='<title id="spidersystem-file-title">'+esc(this.copy.configuration)+'</title><desc id="spidersystem-file-desc">'+esc(summary)+'</desc>'+
        '<metadata id="spidersystem-configuration">'+esc(JSON.stringify(SpiderGeometry.documentData(raw,view)))+'</metadata><style>'+esc(assets.fontCss)+'</style>'+
        '<rect width="900" height="1080" '+fill(p.paper)+'/><g font-family="'+esc(b.body)+'" '+fill(p.forest)+'><rect width="900" height="104" '+fill(p.forest)+'/>'+
        (assets.logo?'<rect x="42" y="20" width="60" height="60" rx="6" '+fill(p.paper)+'/><image x="47" y="25" width="50" height="50" href="'+assets.logo+'"/>':'')+
        text(titleX,46,this.copy.configuration,27,'font-family="'+esc(b.heading)+'" '+fill(p.paper)+' font-weight="'+esc(b.headingWeight)+'"')+
        text(titleX,79,this.copy.download,14,fill(p.paper))+
        text(852,38,company,15,fill(p.paper)+' text-anchor="end"')+
        text(852,65,email,11,fill(p.paper)+' text-anchor="end"')+
        '<rect x="48" y="632" width="804" height="296" rx="8" '+fill(p.sage)+'/>'+
        text(70,663,this.copy.file_data_title,18,'font-weight="700"')+column(left,70)+column(right,470)+
        lines.map((line,i)=>text(48,965+i*18,line,12,fill(p.muted))).join('')+
        '<a href="'+esc(link)+'" target="_blank">'+text(48,1024,this.copy.file_edit_link,14,'text-decoration="underline" font-weight="600"')+'</a>'+
        text(48,1051,this.copy.file_import_note,12,fill(p.muted))+'</g>';
      drawing.setAttribute('x','50');drawing.setAttribute('y','110');
      drawing.setAttribute('width','800');drawing.setAttribute('height','520');
      report.append(drawing);
      return '<?xml version="1.0" encoding="UTF-8"?>\n'+new XMLSerializer().serializeToString(report);
    }
    async openSavedFile(file) {
      const button=this.querySelector('[data-import]');
      const input=this.querySelector('[data-import-file]');
      button.disabled=true;
      try {
        if(file.size>1024*1024) { this.showToolStatus(this.copy.import_too_large,button,'error'); return; }
        const xml=new DOMParser().parseFromString(await file.text(),'image/svg+xml');
        const root=xml.documentElement;
        if(xml.doctype || xml.querySelector('parsererror') || root.localName!=='svg' || root.namespaceURI!=='http://www.w3.org/2000/svg') throw new Error('Invalid SVG');
        const metadata=xml.querySelector('metadata[id="spidersystem-configuration"]');
        if(!metadata || metadata.namespaceURI!==root.namespaceURI) throw new Error('Missing configuration');
        const restored=SpiderGeometry.restoreDocument(JSON.parse(metadata.textContent));
        this.raw=restored.raw; this.view=restored.view;
        this.querySelector('[data-request-status]').textContent='';
        this.syncInputs(); this.setStep(0);
        this.showToolStatus(this.copy.import_loaded,button);
      } catch {
        this.showToolStatus(this.copy.import_invalid,button,'error');
      } finally {
        input.value=''; button.disabled=false;
      }
    }
    render() {
      this.syncRanges();
      this.result=SpiderGeometry.calculate(this.raw);
      const r=this.result;
      const errors=this.querySelector('[data-errors]');
      errors.hidden=r.valid;
      errors.innerHTML=r.valid?'':`<strong>${esc(this.copy.fix)}</strong><ul>${r.errors.map(error=>`<li>${esc(this.errorText(error))}</li>`).join('')}</ul>`;
      this.querySelectorAll('[data-field]').forEach(input=>input.setAttribute('aria-invalid',String(r.errors.some(error=>error.field===input.dataset.field))));
      this.querySelector('[data-next]').disabled=r.errors.some(error=>error.field!=='quantity');
      this.querySelectorAll('[data-submit],[data-download],[data-share]').forEach(button=>{button.disabled=!r.valid || button.hasAttribute('data-download') && this.exporting;});
      this.querySelectorAll('[data-view]').forEach(button=>{button.setAttribute('aria-pressed',String(button.dataset.view===this.view));});
      this.querySelector('[data-stat=area]').textContent=r.drawable?this.f(r.area)+' m²':'—';
      this.querySelector('[data-stat=frame]').textContent=r.drawable?this.f(r.frameWidth)+' × '+this.f(r.frameHeight)+' m':'—';
      this.querySelector('[data-stat=clearance]').textContent=r.drawable?this.f(r.clearance)+' m':'—';
      const status=this.querySelector('[data-status]'); status.dataset.valid=String(r.valid); status.textContent=r.valid?this.copy.valid:this.copy.invalid;
      this.querySelector('[data-summary]').textContent=this.summary();
      this.updateHidden();
      this.querySelector('[data-drawing]').innerHTML=r.drawable?this.drawing():`<p class="sp-drawing-empty">${esc(this.copy.diagram_empty)}</p>`;
    }
    drawing() {
      const b=this.getBranding();
      const r=this.result, v=r.values;
      const scale=Math.min(560/v.wallWidth,360/v.wallHeight);
      const wallW=v.wallWidth*scale, wallH=v.wallHeight*scale;
      const x=(800-wallW)/2, ground=420, top=ground-wallH;
      const frameW=r.frameWidth*scale, frameH=r.frameHeight*scale;
      const frameX=x+(wallW-frameW)/2;
      const systemTop=ground-v.systemHeight*scale;
      const boxY=ground-v.boxHeight*scale;
      const frameY=this.view==='lowered'?boxY-frameH:systemTop;
      const bannerX=frameX+r.sideSpace*scale, bannerY=frameY+r.verticalSpace*scale;
      const bw=v.bannerWidth*scale,bh=v.bannerHeight*scale;
      const wireX=v.wire==='left'?frameX:frameX+frameW;
      const line=(x1,y1,x2,y2,extra='')=>`<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" ${extra}/>`;
      const label=(tx,ty,text,extra='')=>`<text x="${tx}" y="${ty}" ${extra}>${esc(text)}</text>`;
      const dim=(x1,y1,x2,y2)=>line(x1,y1,x2,y2,'stroke="#506451" stroke-width="1" marker-start="url(#'+this.idPrefix()+'-arrow)" marker-end="url(#'+this.idPrefix()+'-arrow)"');
      let wallLines='';
      for(let i=1;i<4;i++) wallLines+=line(x+wallW*i/4,top,x+wallW*i/4,ground,'stroke="#d0d8c5" stroke-width="1"');
      for(let i=1;i<4;i++) wallLines+=line(x,top+wallH*i/4,x+wallW,top+wallH*i/4,'stroke="#d0d8c5" stroke-width="1"');
      const corners=[[frameX,frameY,bannerX,bannerY],[frameX+frameW,frameY,bannerX+bw,bannerY],[frameX,frameY+frameH,bannerX,bannerY+bh],[frameX+frameW,frameY+frameH,bannerX+bw,bannerY+bh]];
      const anchors=corners.map(([ax,ay,bx,by])=>line(ax,ay,bx,by,'stroke="#2a4336" stroke-width="2"')+`<circle cx="${ax}" cy="${ay}" r="4" fill="#2a4336"/>`).join('');
      const fontSize=Math.min(27,Math.max(11,bw/10));
      const svg=`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 520" role="img" aria-labelledby="${this.idPrefix()}-title ${this.idPrefix()}-desc"><title id="${this.idPrefix()}-title">${esc(this.copy.diagram_title)}</title><desc id="${this.idPrefix()}-desc">${esc(this.summary())}</desc><defs><marker id="${this.idPrefix()}-arrow" viewBox="0 0 8 8" refX="4" refY="4" markerWidth="5" markerHeight="5" orient="auto-start-reverse"><path d="M 0 0 L 8 4 L 0 8 z" fill="#506451"/></marker></defs><g font-family="Segoe UI,Arial,sans-serif" font-size="14" fill="#2a4336"><rect x="${x}" y="${top}" width="${wallW}" height="${wallH}" rx="2" fill="#fcfaf3" stroke="#bdc8b4"/>${wallLines}${dim(x,top-18,x+wallW,top-18)}${label(400,top-28,this.copy.step_wall+' '+this.f(v.wallWidth)+' m','text-anchor="middle"')}${dim(x+wallW+24,top,x+wallW+24,ground)}${label(x+wallW+34,top+wallH/2,this.f(v.wallHeight)+' m')}${line(x-25,ground,x+wallW+25,ground,'stroke="#506451" stroke-width="2"')}${label(x,ground+25,this.copy.ground)}<rect x="${frameX}" y="${frameY}" width="${frameW}" height="${frameH}" fill="none" stroke="${r.valid?'#506451':'#aa3422'}" stroke-dasharray="6 5"/><rect x="${bannerX}" y="${bannerY}" width="${bw}" height="${bh}" rx="1" fill="#ffab87" stroke="#d48c6e"/>${anchors}${line(wireX,systemTop,wireX,boxY,'stroke="#2a4336" stroke-width="2"')}<rect x="${wireX-6}" y="${boxY-10}" width="12" height="20" rx="2" fill="#2a4336"/>${line(wireX+6,boxY,wireX+13,boxY,'stroke="#2a4336" stroke-width="2"')}${label(wireX+(v.wire==='left'?-12:16),boxY+4,this.copy.box+' '+this.f(v.boxHeight)+' m',v.wire==='left'?'text-anchor="end"':'')}${label(bannerX+bw/2,bannerY+bh/2-fontSize*.3,this.copy.campaign,`text-anchor="middle" font-size="${fontSize}" font-weight="700"`)}${label(bannerX+bw/2,bannerY+bh/2+fontSize*.9,this.copy.campaign_two,`text-anchor="middle" font-size="${fontSize}" font-weight="700"`)}${dim(bannerX,bannerY+bh+12,bannerX+bw,bannerY+bh+12)}${label(bannerX+bw/2,bannerY+bh+29,this.f(v.bannerWidth)+' × '+this.f(v.bannerHeight)+' m','text-anchor="middle" font-size="12"')}${dim(x-29,systemTop,x-29,ground)}${label(x-38,systemTop+(ground-systemTop)/2,this.f(v.systemHeight)+' m','text-anchor="end"')}${label(400,486,this.view==='lowered'?this.copy.lowered_caption:this.copy.mounted_caption,'text-anchor="middle" font-size="12"')}</g></svg>`;
      return svg.replaceAll('#506451',esc(b.palette.muted)).replaceAll('#d0d8c5',esc(b.palette.line)).replaceAll('#2a4336',esc(b.palette.forest)).replaceAll('#fcfaf3',esc(b.palette.paper)).replaceAll('#bdc8b4',esc(b.palette.line)).replaceAll('#ffab87',esc(b.palette.coral)).replaceAll('#d48c6e',esc(b.palette.forest)).replaceAll('Segoe UI,Arial,sans-serif',esc(b.body));
    }
    idPrefix() { return this.querySelector('[data-panel="0"]').id+'-svg'; }
    save(name,text,type) {

      const url=URL.createObjectURL(new Blob([text],{type}));

      const a=document.createElement('a'); a.href=url; a.download=name; a.click();

      this.downloads ??= new Map();

      this.downloads.set(url,setTimeout(()=>{URL.revokeObjectURL(url);this.downloads.delete(url);},1000));

    }

  }
  customElements.define('vp-spider-component',SpiderConfigurator);
})();
